import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cta: 'Upgrade plan',
    description:
      'The different insurance are available from the Shine Plus plan. Look at all the different insurance below, upgrade and protect your business today!',
    title: 'You do not currently have any insurance',
  },
  fr: {
    cta: 'Passer au plan supérieur',
    description:
      'Les assurances sont disponibles à partir du plan Shine Plus. Retrouvez les différentes assurances ci-dessous et protégez votre activité dès aujourd’hui\xa0!',
    title: 'Vous ne bénéficiez d’aucune assurance pour le moment',
  },
} as const);

export default locales;
